<app-header [forceLightBackground]="true"></app-header>
<div class="provider-support">
  <div class="provider-support--layout">
    <app-provider-sidebar class="provider-support--sidebar"></app-provider-sidebar>
    <div class="provider-support--content">
      <app-page-header></app-page-header>
      <div class="support--container">
        <app-support></app-support>
      </div>
    </div>
  </div>
</div>



